<style src="css/serviceAssistant.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="查看详情"></topbar>
        <ul>
            <li>
                <div class="topBox">
                    {{systemMessage.type | isType}} <span>{{systemMessage.createTime | time}}</span>
                </div>
                <div class="content">
                    {{name}}{{systemMessage.content}}
                </div>
                <a :href="systemMessage.url" target="_blank" class="bottomBox" v-if="systemMessage.url">点击查看详情</a>
            </li>
        </ul>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                messageId: '',
                name: '',
                systemMessage: {},
                systemMessageList:[]
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {
            isType(value){
                let arr = ['访问主页','预约咨询','开始咨询','结束咨询','取消咨询']
                return arr[value]
            },
            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async getSystemMessageDetailForUser() {
                let data = await getSources("/bear-scale/api/systemMessage/getSystemMessageDetailForUser.json", {
                    userId: localStorage.getItem('userId'),
                    messageId: this.messageId,
                });
                if (data.status === 0) {
                    this.name = data.name;
                    this.systemMessage = data.systemMessage;
                }else{
                    alert(data.msg)
                }
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
        },
        destroyed() {

        },
        mounted() {
            this.messageId = this.$route.query.messageId
            this.getSystemMessageDetailForUser()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/serviceAssistantDetail.vue?4dc977cf